import React from "react";
import { Helmet } from 'react-helmet';
import Slider from "react-slick";
import { Link } from 'react-router-dom'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from '../../images/slider/slide-4.jpg';
import hero2 from '../../images/slider/slide-5.jpg';


const settings = {
    dots: false,
    arrows: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    fade: true
};

const Hero4 = () => {
    return (
        <section className="wpo-hero-slider">
            <div className="hero-container">
                <Helmet>
                    <title>Ipsodia</title>
                </Helmet>
                <div className="hero-wrapper">
                    <Slider {...settings}>
                        <div className="hero-slide">
                            <div className="slide-inner slide-bg-image responsive-image" style={{ backgroundImage: `url(${hero1})` }}>
                                <div className="container-fluid">
                                    <div className="slide-content">
                                        <div className="slide-title-sub">
                                            <h5>Votre Partenaire de Confiance</h5>
                                        </div>
                                        <div className="slide-title">
                                            <h2>Vous recherchez une solution digitale</h2>
                                        </div>
                                        <div className="slide-text">
                                            <p><b>Nous concrétisons vos idées de la conception jusqu'à la prise en main du produit </b></p>
                                            <p><i>Le développement d'applications web ou mobile de qualité est notre passion.</i></p>
                                        </div>
                                        {/* <div className="btns">
                                            <Link to="/about" className="theme-btn">Découvrir</Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="hero-slide">
                            <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero2})` }}>
                                <div className="container-fluid">
                                    <div className="slide-content">
                                        <div className="slide-title-sub">
                                            <h5>Votre Partenaire de Confiance</h5>
                                        </div>
                                        <div className="slide-title">
                                            <h2>Vous avez un besoin métier</h2>
                                        </div>
                                        <div className="slide-text">
                                            <p><b>Nous vous accompagnons pour créer  
                                            l'application qui vous apportera toute satisfaction</b></p>
                                            <p><i>L'écoute et l'analyse des besoins clients forment le socle de notre démarche projet.</i></p>
                                        </div>
                                        {/* <div className="btns">
                                            <Link to="/about" className="theme-btn">Découvrir</Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default Hero4;